import findIndex from 'lodash/findIndex';
import unionBy from 'lodash/unionBy';
import {ActionType} from 'redux-promise-middleware';
import SpotUtils from 'utils/spot';
import {DESTINATION_LOAD_EVENTS} from 'destination/destination-actions';
import {FILTERS_UPDATE} from 'filters/filters-actions';
import {ROUTER_DATA_LOAD_FULFILLED} from 'router/router-actions';
import {SEARCH_SET_SORT_TYPE} from 'search/search-actions';
import {SEARCH_REQUEST_SET_TERM} from 'search-request/search-request-actions';
import {
    SPOT_GET_TRAVEL_DISTANCE,
    SPOT_GET_AIRPORT_TRAVEL_DISTANCE,
} from 'spot/spot-actions';
import {
    SPOTS_GET_RADIAL,
    SPOTS_GET_TILED,
    SPOTS_GET_TRAVEL_DISTANCES,
    SPOTS_RADIAL_INCREMENT,
    SPOTS_TILED_INCREMENT,
    SPOTS_GET_AIRPORT,
    SPOTS_GET_MOBILE,
    SPOTS_GET_MOBILE_PAGINATION,
    SPOTS_SET_SPOT_SELECTED_RATE,
    SPOTS_SET_SELECTED_SPOT_ID,
} from './spots-actions';

const initialState = {
    isPending: true,
    airportPendingRequests: [],
    data: [],
    selectedSpotId: null,
    error: null,
};

export default function spots(state = initialState, {type, payload, meta}) {
    switch (type) {
        case SEARCH_REQUEST_SET_TERM:
        case ROUTER_DATA_LOAD_FULFILLED: {
            return {
                ...initialState,
            };
        }

        case `${DESTINATION_LOAD_EVENTS}_${ActionType.Pending}`:
        case `${SPOTS_GET_RADIAL}_${ActionType.Pending}`:
        case `${SPOTS_GET_MOBILE}_${ActionType.Pending}`: {
            return {
                ...initialState,
                selectedSpotId: state.selectedSpotId,
            };
        }

        case `${SPOTS_GET_AIRPORT}_${ActionType.Pending}`: {
            return {
                ...initialState,
                airportPendingRequests: [
                    ...state.airportPendingRequests,
                    {
                        requestId: meta.requestId,
                    },
                ],
            };
        }

        case `${SPOTS_GET_RADIAL}_${ActionType.Fulfilled}`:
        case `${SPOTS_GET_TILED}_${ActionType.Fulfilled}`: {
            return {
                ...state,
                isPending: false,
            };
        }

        case `${SPOTS_GET_RADIAL}_${ActionType.Rejected}`:
        case `${SPOTS_GET_TILED}_${ActionType.Rejected}`:
        case `${SPOTS_GET_MOBILE}_${ActionType.Rejected}`:
        case `${SPOTS_GET_MOBILE_PAGINATION}_${ActionType.Rejected}`: {
            return {
                ...state,
                isPending: false,
                error: payload,
            };
        }

        case `${SPOTS_GET_AIRPORT}_${ActionType.Rejected}`: {
            return {
                ...state,
                isPending: false,
                error: payload,
                airportPendingRequests: state.airportPendingRequests.filter(
                    val => val.requestId !== payload.requestId
                ),
            };
        }

        case SPOTS_RADIAL_INCREMENT: {
            const {results, searchRequestState, timezone} = payload;

            return {
                ...state,
                data: [
                    ...state.data,
                    ...SpotUtils.prepareGroup({
                        spots: results,
                        searchRequest: searchRequestState,
                        timezone,
                    }),
                ],
            };
        }

        case `${SPOTS_GET_TILED}_${ActionType.Pending}`:
        case `${SPOTS_GET_MOBILE_PAGINATION}_${ActionType.Pending}`: {
            return {
                ...state,
                isPending: true,
            };
        }

        case SPOTS_TILED_INCREMENT: {
            const {results, searchRequestState, timezone} = payload;

            return {
                ...state,
                data: unionBy(
                    state.data,
                    SpotUtils.prepareGroup({
                        spots: results,
                        searchRequest: searchRequestState,
                        timezone,
                    }),
                    'parking_spot_id'
                ),
            };
        }

        case `${SPOTS_GET_AIRPORT}_${ActionType.Fulfilled}`: {
            const {results, searchRequestState, timezone} = payload;

            return {
                ...state,
                data: [
                    ...state.data,
                    ...SpotUtils.prepareGroup({
                        spots: results,
                        searchRequest: searchRequestState,
                        timezone,
                    }),
                ],
                isPending: false,
                airportPendingRequests: state.airportPendingRequests.filter(
                    val => val.requestId !== payload.requestId
                ),
            };
        }

        case `${SPOTS_GET_MOBILE}_${ActionType.Fulfilled}`:
        case `${SPOTS_GET_MOBILE_PAGINATION}_${ActionType.Fulfilled}`: {
            const {results, searchRequestState, timezone} = payload;

            return {
                ...state,
                data: [
                    ...state.data,
                    ...SpotUtils.prepareGroup({
                        spots: results,
                        searchRequest: searchRequestState,
                        timezone,
                    }),
                ],
                isPending: false,
            };
        }

        case SEARCH_SET_SORT_TYPE:
        case FILTERS_UPDATE: {
            // when these actions are fired just set the spots to themselves so that
            // the selector runs on the data and updates the component props accordingly
            return {
                ...state,
                data: state.data,
            };
        }

        case `${SPOT_GET_AIRPORT_TRAVEL_DISTANCE}_${ActionType.Fulfilled}`:
        case `${SPOT_GET_TRAVEL_DISTANCE}_${ActionType.Fulfilled}`:
        case `${SPOTS_GET_TRAVEL_DISTANCES}_${ActionType.Fulfilled}`: {
            return {
                ...state,
                data: unionBy(payload[0], state.data, 'parking_spot_id'),
            };
        }

        case SPOTS_SET_SPOT_SELECTED_RATE: {
            const allSpots = [...state.data];
            const spot = payload.spotWithNewRate;
            const index = findIndex(allSpots, {
                // eslint-disable-next-line camelcase
                parking_spot_id: spot.parking_spot_id,
            });

            if (index !== -1) {
                allSpots.splice(index, 1, spot);
            }

            return {
                ...state,
                data: allSpots,
            };
        }

        case SPOTS_SET_SELECTED_SPOT_ID: {
            const {spotId} = payload;

            return {
                ...state,
                selectedSpotId: spotId,
            };
        }

        default:
            return state;
    }
}
